export interface Expense {
  id: string;
  contractDate: Date;
  description: string;
  contractNumber: string;
  contractAmount: string;
  repaymentDate: Date;
  nextInstallment: string;
  status: Status;
  paymentSchedule: PaymentSchedule[];
  interest: number;
  accessToDetails: boolean;
  token: string;
  wcsToken: string;
  token30days: string;
}

export enum Status {
  OVERDUE = 'OVERDUE',
  TO_BE_REPAID = 'TO_BE_REPAID',
  UPCOMING = 'UPCOMING',
  REPAID = 'REPAID',
  REPAYMENT_BREAK = 'REPAYMENT_BREAK',
  IN_PROCESS = 'W procesie'
}

export interface Input {
  expense: Expense[];
  columns: ColumnDefinition;
  expandedRowId: string;
}

export interface ColumnDefinition {
  type: string;
  format: string;
  name: string;
  header: string;
  style: string;
}

export interface PaymentSchedule {
  installmentNumber: number;
  paymentDate: string;
  status: Status;
  amount: number;
}

export const statusValues: Record<Status, string> = {
  [Status.OVERDUE]: 'Zaległa',
  [Status.TO_BE_REPAID]: 'Do spłaty',
  [Status.UPCOMING]: 'Przyszła',
  [Status.REPAID]: 'Spłacona',
  [Status.REPAYMENT_BREAK]: 'Przerwa w spłacie',
  [Status.IN_PROCESS]: 'W procesie',
};
